import { IEquipmentHisotryLines } from 'interfaces';
import { axiosPrivate } from 'services/axios';
import { BaseService } from '../BaseService';

class EquipmentHistoryLineService extends BaseService<IEquipmentHisotryLines> {
  constructor() {
    super('equipments-history-lines');
  }

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };
}

export const equipmentHistoryLineService = new EquipmentHistoryLineService();
